import * as React from 'react';
import { connect } from 'react-redux';
import IInvestBtnComponent from './IInvestBtnComponent';

import * as style from './InvestBtnComponentStyle.module.scss'

const InvestBtnComponent: React.SFC<IInvestBtnComponent> = (props) => {

  const { livePitch, isUsInvestor, editMode } = props;
  return (
    <React.Fragment>
      {!isUsInvestor && livePitch && !editMode ? (
        <a className={[style.button, style.buttonPublic].join(' ')} href={`/pitches/${livePitch}`}>
            View live pitch
        </a>
        ) : null
      }
    </React.Fragment>
  );
};

const mapStateToProps = (store: any) => {
  return {
    livePitch: store.companyReducer.companyDetails.live_pitch,
  };
};
export default connect(mapStateToProps)(InvestBtnComponent);
